import React from 'react'

import { BasicComponent } from '../..'
import styles from './index.module.scss'

export interface CardProps extends BasicComponent {
  children?: React.ReactNode
  className?: string
}

const Card: React.FC<CardProps> = ({ children, className }) => (
  <div className={[styles.Card, className].join(' ')}>{children}</div>
)

export default Card
